import { httpClient } from './http-client';

export const getLabels = async () => {
  try {
    const response = await httpClient.get('api/label_files.php');
    return response.data;
  } catch (error) {
    throw new Error('Error fetching files list');
  }
};
